module.exports = __webpack_public_path__ + "img/vk.3333165a.svg";